import { Button, Stack, Typography } from "@mui/material";
import { ReactNode } from "react";
import { BoZoneCallout } from "../../layer01";

type BoZoneSuggestionCardProps = {
  title: string;
  body: string;
  actionLabel: string;
  actionIcon: ReactNode;
  onAction?: () => void;
  isActionDisabled?: boolean;
};

export const BoZoneSuggestionCard = (props: BoZoneSuggestionCardProps) => (
  <BoZoneCallout>
    <Stack
      direction={{ xs: "column", sm: "row" }}
      alignItems={{ xs: "flex-start", sm: "center" }}
      justifyContent="space-between"
      gap="1.5rem"
    >
      <Stack direction="column" rowGap=".75rem" minWidth={0}>
        <Typography variant="cardSectionTitle">{props.title}</Typography>
        <Typography variant="cardBodyRegular" color="#202D63">
          {props.body}
        </Typography>
      </Stack>
      <Button
        variant="contained"
        startIcon={props.actionIcon}
        onClick={props.onAction}
        disabled={props.isActionDisabled}
        sx={{ flexShrink: 0 }}
      >
        {props.actionLabel}
      </Button>
    </Stack>
  </BoZoneCallout>
);
